import axios from '../../axios';
import dayjs from '../../dayjs';

// initial state
const state = {
    list: {},
};

// getters
const getters = {
    datepickerHighlighted(state) {
        return {
            dates: Object.entries(state.list).map(v => dayjs(v[0]).toDate()),
        };
    },
    find: (state) => (date) => {
        return state.list[dayjs(date).format('YYYY-MM-DD')];
    },
};

// actions
const actions = {
    fetch: async function(context) {
        const res = await axios.get('https://holidays-jp.github.io/api/v1/date.json');
        context.commit('set', res.data);
    },
};

// mutations
const mutations = {
    set(state, value) {
        state.list = value;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
